import PropTypes from 'prop-types';
import { useState } from 'react';

import { Button } from '@hivebrite/design-system/Button';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

const MoreInfoButton = ({ htmlBlock, variant = 'primary' }) => {
  const [modalInformationsOpened, setModalInformationsOpened] = useState(false);

  return (
    <>
      <Button
        isFullWidth
        variant={variant}
        onClick={() => setModalInformationsOpened(true)}
      >
        {__('More information')}
      </Button>

      {modalInformationsOpened && (
        <ModalWithTemplate
          header={__('More information')}
          screenReadersCloseButtonText={s__(
            'Accessibility|Close more information window',
          )}
          onCloseModal={() => setModalInformationsOpened(false)}
        >
          <div
            className="ckeditor-content--reset"
            dangerouslySetInnerHTML={{ __html: htmlBlock }}
          />
        </ModalWithTemplate>
      )}
    </>
  );
};

MoreInfoButton.propTypes = {
  htmlBlock: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

export default MoreInfoButton;
